import { Vehicle } from "./../Interfaces/vehicle.type";

export const checkIsEligibleForDelivery = (vehicle: Vehicle) => {
  const isEligibleForDelivery =
    vehicle.isEligibleForDelivery === true &&
    vehicle.isOrderReferenceAdded === false;

  return isEligibleForDelivery;
};
